import { useCartContext } from 'components/Cart/cartContext';

type SumPerDay = {
  [key: string]: number;
};

export const useNotSavedOrderPrices = () => {
  const { meals } = useCartContext();

  const dateOrderSum: SumPerDay = {};

  // todo: combine1
  Object.entries(meals).forEach(([id, { item, quantity, day }]) => {
    const previousSum = dateOrderSum[day] || 0;

    dateOrderSum[day] = previousSum + (item.price ?? 0) * quantity;
  });

  return dateOrderSum;
};
